<template>
  <v-tooltip
    v-if="(hasOverflow || show) && isTooltipEnabled"
    :top="top"
    :bottom="bottom"
    :class="`label-tooltip ${className}`">
    <template v-slot:activator="{on, attrs}">
      <div
        v-bind="attrs"
        v-on="on"
        class="label-tooltip limit-width inner-content"
        :style="`--max-width: ${maxWidth}`"
        ref="content">
        <slot></slot>
      </div>
    </template>
    <div :style="`max-width: ${maxWidth}; word-wrap: break-word;`">
      <slot v-if="hasTooltipSlot" name="tooltip"></slot>
      <slot v-else></slot>
    </div>
  </v-tooltip>
  <div v-else class="label-tooltip limit-width inner-content" :style="`--max-width: ${maxWidth}`" ref="content">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, ref} from '@vue/composition-api'

export default defineComponent({
  name: 'LabelTooltip',
  props: {
    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: String,
      default: '200px',
    },
    show: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: '',
    },
    isTooltipEnabled: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, {refs, slots, root}) {
    const hasTooltipSlot = computed(() => {
      return !!slots.tooltip
    })
    const hasOverflow = ref(false)

    onMounted(() => {
      root.$nextTick(() => {
        const element = refs.content as HTMLElement

        if (element) {
          for (const child of element.children) {
            if (hasElementOverflow(child)) {
              hasOverflow.value = true
              break
            }
          }
        }
      })
    })

    function hasElementOverflow(element: Element) {
      return element?.scrollHeight > element?.clientHeight || element?.scrollWidth > element?.clientWidth
    }
    return {
      hasTooltipSlot,
      hasOverflow,
    }
  },
})
</script>

<style lang="scss">
.label-tooltip.limit-width {
  --max-width: 200px;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;

  * {
    max-width: var(--max-width);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
